// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CurrencyValue: shared component, so its styles travel with it via
   an import in CurrencyValue.tsx. Previously these lived in dashboard.css
   which is only loaded by Dashboard.tsx; that left the same classes
   un-styled on Campaigns / other pages. */

.currency-value {
  display: inline-flex;
  align-items: baseline;
}

.currency-symbol {
  font-size: 0.7em;
  font-weight: 400;
  color: var(--text-tertiary, #999);
  margin-right: 2px;
}

.currency-symbol.large {
  font-size: 0.5em;
  margin-right: 6px;
}

.currency-cents {
  font-size: 0.9em;
  color: var(--text-tertiary, #999);
}

.currency-cents.large {
  font-size: 0.55em;
}

/* Tooltip — instant, themed. Replaces native title which has
   inconsistent timing across browsers and sometimes never appears. */
.has-tooltip {
  position: relative;
}

.has-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  padding: 6px 10px;
  background: #1f2937;
  color: #fff;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  letter-spacing: 0;
  line-height: 1.2;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 120ms ease, transform 120ms ease, visibility 0s linear 120ms;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.has-tooltip::before {
  content: '';
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  border: 5px solid transparent;
  border-top-color: #1f2937;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 120ms ease, transform 120ms ease, visibility 0s linear 120ms;
  z-index: 1000;
}

.has-tooltip:hover::after,
.has-tooltip:hover::before {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
  transition: opacity 120ms ease, transform 120ms ease;
}
`, "",{"version":3,"sources":["webpack://./src/styles/currency-value.css"],"names":[],"mappings":"AAAA;;;0CAG0C;;AAE1C;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;qEACqE;AACrE;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,gFAAgF;EAChF,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2CAA2C;EAC3C,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,gFAAgF;EAChF,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,oDAAoD;AACtD","sourcesContent":["/* CurrencyValue: shared component, so its styles travel with it via\n   an import in CurrencyValue.tsx. Previously these lived in dashboard.css\n   which is only loaded by Dashboard.tsx; that left the same classes\n   un-styled on Campaigns / other pages. */\n\n.currency-value {\n  display: inline-flex;\n  align-items: baseline;\n}\n\n.currency-symbol {\n  font-size: 0.7em;\n  font-weight: 400;\n  color: var(--text-tertiary, #999);\n  margin-right: 2px;\n}\n\n.currency-symbol.large {\n  font-size: 0.5em;\n  margin-right: 6px;\n}\n\n.currency-cents {\n  font-size: 0.9em;\n  color: var(--text-tertiary, #999);\n}\n\n.currency-cents.large {\n  font-size: 0.55em;\n}\n\n/* Tooltip — instant, themed. Replaces native title which has\n   inconsistent timing across browsers and sometimes never appears. */\n.has-tooltip {\n  position: relative;\n}\n\n.has-tooltip::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%) translateY(4px);\n  padding: 6px 10px;\n  background: #1f2937;\n  color: #fff;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  letter-spacing: 0;\n  line-height: 1.2;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 120ms ease, transform 120ms ease, visibility 0s linear 120ms;\n  z-index: 1000;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.has-tooltip::before {\n  content: '';\n  position: absolute;\n  bottom: calc(100% + 2px);\n  left: 50%;\n  transform: translateX(-50%) translateY(4px);\n  border: 5px solid transparent;\n  border-top-color: #1f2937;\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 120ms ease, transform 120ms ease, visibility 0s linear 120ms;\n  z-index: 1000;\n}\n\n.has-tooltip:hover::after,\n.has-tooltip:hover::before {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(0);\n  transition: opacity 120ms ease, transform 120ms ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
